import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=0a8f79ab&scoped=true&"
import script from "./AccountSetup.vue?vue&type=script&lang=js&"
export * from "./AccountSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8f79ab",
  null
  
)

export default component.exports